/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const layoutStyle = {
  pageContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: "1 0 auto",
    backgroundRepeat: "no-repeat",
  },
  childrenContainer: {
    paddingTop: "77px",
  },
  blockPage: {
    textAlign: "center",
    padding: "20px",
    paddingTop: "200px",
    width: "100%",
    height: "100%",
    position: "fixed",
    left: "0",
    top: "0",
    zIndex: "2000",
    backgroundColor: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(2px)",
    color: "white",
  },
  navigationContainer: {},
};

export default layoutStyle;
